import { useState } from "react";
import { showMessage } from "react-native-flash-message";
import { requestHelper } from "../helpers/request-helper";

export function useUpdateCartItem() {
  let [loadingAddItem, setLoadingAddItem] = useState(false);
  let [loadingRemoveItem, setLoadingRemoveItem] = useState(false);

  function addItem({ service, variation }) {
    setLoadingAddItem(true);
    return requestHelper(
      `
          mutation addItem($service: String!, $variation: String!) {
            addItemToCart(service: $service, variation: $variation) {
              id
              service
            }
          }
        `,
      {
        service: service,
        variation: variation,
      }
    )
      .then((data) => {
        return data;
      })
      .catch(() => {
        showMessage({
          message: "مشکلی در اتصال به سرور پیش آمده",
          type: "danger",
        });
      })
      .finally(() => {
        setLoadingAddItem(false);
      });
  }
  function removeItem({ service, variation }) {
    setLoadingRemoveItem(true);
    return requestHelper(
      `
        mutation removeItem($service: String!, $variation: String!) {
          removeItemFromCart(service: $service, variation: $variation) {
            id
            service
          }
        }
      `,
      {
        service: service,
        variation: variation,
      }
    )
      .then((data) => {
        return data;
      })
      .catch(() => {
        showMessage({
          message: "مشکلی در اتصال به سرور پیش آمده",
          type: "danger",
        });
      })
      .finally(() => {
        setLoadingRemoveItem(false);
      });
  }

  return { addItem, removeItem, loadingAddItem, loadingRemoveItem };
}
